import { render, staticRenderFns } from "./audit-log-table.vue?vue&type=template&id=add3eb44&"
import script from "./audit-log-table.vue?vue&type=script&lang=js&"
export * from "./audit-log-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports